// JsFromRoutes CacheKey 125534c4f0c9a2a97d0c7a202b60e536
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/admin/quoting/smart_census_parse_jobs'),
  new: /* #__PURE__ */ definePathHelper('get', '/admin/quoting/smart_census_parse_jobs/new'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/quoting/smart_census_parse_jobs/:id'),
}
